import getLogger from '@ignitesales/logger-es';
import { buildPageUrl, ignite, startNewGuide } from '@ignitesales/neuro-application';
import queryString from 'query-string';

const logger = getLogger({ module: 'royal-consumer-online-actions' });

const RoyalConsumerOnlineActions = {
  DEEP_LINK_CHECK_FINISHED: 'DEEP_LINK_CHECK_FINISHED'
};

const checkAndGoToDeepLink = () => {
  const validPaths = ['checking', 'savings', 'borrow'];
  const allPathsOption = 'all';

  return async (dispatch, getState) => {
    try {
      const urlQuery = window.location.search;

      // Begin a new guide if newUser does not exist in the url
      if(urlQuery !== '' && !urlQuery.includes('newUser')){
        window.location.href = startNewGuide({params: {...queryString.parse(urlQuery), newUser: true}});
        return;
      }

      logger.debug('Checking for deep link', urlQuery);
      const parsed = queryString.parse(urlQuery);
      const pathParam = parsed.path || '';
      const state = getState();

      // Provision a new uuid if one does not exist
      const uuid = state.user?.uuid

      if ( pathParam && (validPaths.includes(pathParam) || pathParam === allPathsOption) ) {
        let preferredPath = pathParam === allPathsOption ? [] : [pathParam];

        logger.debug('Saving answers via deep link', preferredPath);
        await ignite.answerService.saveAnswer({
          appkey: 'reasonForVisit',
          value: preferredPath,
          timestamp: new Date()
        });

        const redirectUrl = buildPageUrl({
          type: 'survey',
          uuid,
          path: { key: 'entry' },
          page: { key: 'reasonForVisit' }
        });
        logger.debug('redirecting via deep link', redirectUrl)
        window.location.href = redirectUrl;
      } else {
        dispatch({ type: RoyalConsumerOnlineActions.DEEP_LINK_CHECK_FINISHED });
      }
    } catch (ex) {
      dispatch({ type: RoyalConsumerOnlineActions.DEEP_LINK_CHECK_FINISHED })
    }
  }
}

export {
  RoyalConsumerOnlineActions,
  checkAndGoToDeepLink
};

